const fixtureFamilies = {
  FIXTURE: 0,
  OBJECT: 1,
  LASER: 2,
  OTHER: 3,
}

export default fixtureFamilies
